import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}

export function formatRelativeDate(iso: string, now = new Date()): string {
    const date = new Date(iso);
    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.round(diffMs / 60_000);

    if (diffMinutes < 1) return "just now";
    if (diffMinutes < 60) return `${diffMinutes} min ago`;
    const diffHours = Math.round(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours} h ago`;
    const diffDays = Math.round(diffHours / 24);
    if (diffDays < 7) return `${diffDays} d ago`;
    return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function getInitials(name: string | null | undefined): string {
    // "Bijo Varghese (Jira)" → "BV", not "B(": drop (…)/[…]/<…> asides and
    // any word that doesn't start with a letter or digit.
    const raw = (name ?? "").trim();
    const cleaned = raw.replace(/\([^)]*\)|\[[^\]]*\]|<[^>]*>|"/g, " ");
    const words = cleaned.split(/\s+/).filter((w) => /^[\p{L}\p{N}]/u.test(w));
    const parts = words.length > 0 ? words : raw.split(/\s+/);
    if (parts.length === 0) return "?";
    const first = parts[0]?.[0] ?? "";
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? "" : "";
    return (first + last).toUpperCase() || "?";
}
